import { initializeApp, FirebaseApp } from "firebase/app";
import { getMessaging, Messaging, isSupported } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBvEwJeCy7APuEdUOVAUXBFWhXzz9dwY1M",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "wenext-3dd96.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "wenext-3dd96",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "wenext-3dd96.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "814696009416",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:814696009416:web:0950e8a292f564d724dffd",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-TMK9SR89BK",
};

export const VAPID_KEY =
  import.meta.env.VITE_FIREBASE_VAPID_KEY ||
  "BKJf_AIQaoblbGxlh1J4o24pn59zaXSZWa6CtISo-qnEsKRbYFG3Rq0akMYOunF6gBcptHjyyJZNqlO3mzHkg2I";

let firebaseApp: FirebaseApp | null = null;
let messagingInstance: Messaging | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (!firebaseApp) {
    firebaseApp = initializeApp(firebaseConfig);
  }
  return firebaseApp;
}

export async function getFirebaseMessaging(): Promise<Messaging | null> {
  try {
    const supported = await isSupported();
    if (!supported) {
      console.warn("[Firebase] Messaging not supported in this browser");
      return null;
    }
    if (!messagingInstance) {
      messagingInstance = getMessaging(getFirebaseApp());
    }
    return messagingInstance;
  } catch (error) {
    console.error("[Firebase] Failed to initialize messaging:", error);
    return null;
  }
}
